import template from './async-download-template.html';

@Inject('$transclude', 'Notifications', 'gettextCatalog')
class AsyncDownloadController {
  constructor() {
    this.isButtonDetails = this.$transclude.isSlotFilled('buttonDetails');
  }

  $onInit(){
    this.parsedType = this.type * 1;
    if (this.parsedType === 3) {
      this.dropdownType = 'label';
    } else if (this.parsedType === 4) {
      this.dropdownType = 'button';
    }
  }

  triggerDownload(file = {}) {
    this.Notifications.alertSuccess(this.gettextCatalog.getString('Exporting data, please wait'));

    this.downloadFunction(file)
      .promise.then((result) => {
          const filename = this.generateFilename(file, result);
          window.saveAs(result.data, filename);
        })
      .catch((error) => {
        this.Notifications.alertError(this.gettextCatalog.getString('Cannot export the report, please try again'));
        console.error('Cannot export the report,', error);
      });
  }

  generateFilename(file, result) {
    const header = result.headers('content-disposition');
    const filenameRegex = /filename="(.+)"/;
    const customFilename = file.customFileName || file.fileName;

    if (customFilename) return `${customFilename}.${file.extension}`;

    if (!header) throw new Error('content-disposition header is missing');

    const filename = header.match(filenameRegex)[1];

    return filename;
  }
}

// types:
// 1 - label
// 2 - button
// 3 - label with dropdown
// 4 - button with dropdown

export default class AsyncDownloadComponent {
  constructor() {
    this.template = template;
    this.transclude = {
      buttonDetails: '?buttonDetails',
      labelDetails: '?labelDetails',
    };
    this.controller = AsyncDownloadController;
    this.bindings = {
      downloadFunction: '&',
      data: '<',
      type: '@?',
      position: '@?',
      additionalClasses: '@?',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/download-element/components/async-download/async-download-component.js